<template>
  <EmailComponentsByRegulatorColumn />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
